import styled from 'styled-components';

export const MainDiv = styled.div`
  height: 100vh;
  width: 100vw;
  background: #f7f8f9;
  display: flex;
  color: #1e2228;
`;

export const ColumnDiv = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
  padding: 0 36px;
  background-color: #f7f8f9 !important;
  overflow: scroll;
`;

export const CLMWrap = styled.div`
    padding: 60px 50px 50px;
    width: 100%;
    height: 100vh;
    overflow: scroll;
`

export const Header = styled.p`
    font-size: 24px;
    line-height: 29px;
    font-weight: 700;
    color: #1E2228;
    margin: 10px 0;
`

export const CLMContent = styled.div`
    background-color: #FFFFFF;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.04);
    border-radius: 8px;
`

export const InputWrap = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 30px;
  & input {
    // width: 600px;
    height: 55px;
    border: 1px solid ${props => props.error ? '#E74C3C' : '#c9c9c9'};
    &:focus {
      border: 1px solid #1B49EA;
    }
  }
  & select {
    // width: 600px;
    height: 55px;
    border: 1px solid #c9c9c9;
    &:focus {
      border: 1px solid #1B49EA;
    }
  }
  & textarea {
    width: 600px;
    border: 1px solid ${props => props.error ? '#E74C3C' : '#c9c9c9'};
    padding: 13px 15px;
    font-family: sans-serif;
    line-height: 18px;
    &:focus {
      border: 1px solid #1B49EA;
    }
  }
`;

export const InputTitleDiv = styled.div`
  // font-size: 14px;
  width: 600px;
  font-weight: 600;
  margin-bottom: 10px;
`;

export const InputErrorDiv = styled.div`
  height: 18px;
  font-size: 12px;
  color: #E74C3C;
  padding-top: 2px;
`;

export const Gap = styled.div`
  height: ${props => props.height};
  width: 100%;
`

export const Footer = styled.div`
  // max-width: 616px;
  width: 100%;
  display: flex;
  align-items: center;
  color:red;
  // justify-content: flex-end;
  margin-left: 15px;
`;

export const Button = styled.button`
  font-size: 16px;
  line-height: 18px;
  font-weight: 700;
  color: #fff;
  background-color: #1B49EA;
  border-radius: 8px;
  text-align: center;
  height: 57px;
  width: 144px;

  &:hover {
    background-color: #fff;
    border: 1px solid #1B49EA;
    color: #1B49EA;
  }
`

export const ButtonWrap = styled.div`
  width: 630px;
  display: flex;
  justify-content: flex-end;
  padding: 30px 0px;
`;

